<svg width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg' preserveAspectRatio='xMidYMid meet' {...$$restProps}>
  <path d='M22 1v9.842L11 11V2.533L22 1zM2 3.946L9 3v7.903L2 11V3.946zm9 17.52V13l11 .158V23l-11-1.533zm-9-1.412V13l7 .098V21l-7-.946z' fill='currentColor' fill-rule='evenodd' />
</svg>
